import {
	Avatar,
	Button,
	Center,
	Menu,
	MenuButton,
	MenuDivider,
	MenuList,
	Text,
} from '@chakra-ui/react'
import { useLocation } from '@remix-run/react'
import { Link } from '~/components'
import { useUser } from '~/hooks'

export let UserMenu = () => {
	let user = useUser()
	let location = useLocation()

	// don't display on login
	if (location.pathname.startsWith('/auth/email-sent')) return null
	if (location.pathname.startsWith('/auth/login-d3v3l0p3rs')) return null
	if (location.pathname === '/auth/login') return null
	if (location.pathname.startsWith('/auth/logout')) return null
	if (location.pathname.startsWith('/auth/magic')) return null

	return user ? (
		<Menu>
			<MenuButton
				as={Button}
				rounded={'full'}
				variant={'link'}
				cursor={'pointer'}
				minW={0}
			>
				<Avatar
					name={user.denominazione}
					size={'sm'}
					//src={user.image || undefined}
				/>
			</MenuButton>
			<MenuList alignItems={'center'} zIndex={2} >
				<Center m={2}>
					
						<Text>
							{user.account_type === 'BENEFICIARIO'
								? 'AZIENDA: ' + user.denominazione
								: user.denominazione}
						</Text>
				</Center>
				{user.ruoli_user === 'DEL' ? (
					<Center m={2}>
						<Text>DELEGATO: {user.cf_spid}</Text>{' '}
					</Center>
				) : user.ruoli_user === 'REL' ? (
					<Center m={2}>
						<Text>RAPPRESENTANTE: {user.cf_spid}</Text>{' '}
					</Center>
				) : (
					<Center m={2}>
						<Text>
							{' '}
							(
							{user.ruoli_user_desc &&
							user.ruoli_user_desc.length > 0
								? user.ruoli_user_desc.join(' ')
								: user.account_type}
							)
						</Text>
					</Center>
				)}

				<MenuDivider />
				<form action="/auth/logout" method="post">
					<input type='hidden' name='spid' value={user.cf_spid ? 'si' : 'no'}/>
					<Center>
						<Button type="submit" variant="ghost" w={'80%'}>
							Logout
						</Button>
					</Center>
				</form>
			</MenuList>
		</Menu>
	) : (
		<Link to="/auth/login">
			<Button
				display={{ base: 'none', md: 'inline-flex' }}
				fontSize={'lg'}
				fontWeight={600}
			>
				Log In
			</Button>
		</Link>
	)
}
